import React from 'react';
import PropTypes from 'prop-types';

// This is a collection of common small dumb components
export const SvgIcon = (props) => {
  const { className, role, svgIcon } = props;
  return (
    <svg className={className} viewBox={svgIcon.viewBox} role={role} focusable="false" aria-hidden="true">
      <use xlinkHref={`#${svgIcon.id}`} />
    </svg>
  );
};
SvgIcon.propTypes = {
  className: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  svgIcon: PropTypes.object.isRequired,
};


export const formatRouteDesc = (headsign, route) => [headsign.route_short_name, route.trip_headsign].join(' - ');
